import axios from "axios";

class AccountRestrictedService {

    constructor() {
        this.apiBaseUrl = process.env.REACT_APP_RESTRICTED_ACCOUNT_URL;
        this.restClient = axios.create({
            baseURL: this.apiBaseUrl
        });
    }
    getAccountInfo(accNumber) {
        return this.restClient.get(`/${accNumber}/info`)
    }

    isBusinessAccount(accNumber) {
        return this.restClient.get(`/siebelbusienssaccount/${accNumber}`)
    }

}

export default new AccountRestrictedService();